module.exports = __webpack_public_path__ + "static/img/6302_phase_function_Paper_PointsHejduk_Prediction.c20ca58.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6302_phase_function_Paper_PointsHejduk_Prediction.png
// module id = a3oD
// module chunks = 0